import { combineReducers } from "redux";
import {
  YEAR_To_DATE_FETCH_ALL,
  TRX_BRISTORE_FETCH_ALL,
  CONTAINER_VOYAGE_FETCH_ALL,
  RUAS_TRAYEK_FETCH_ALL,
  RUAS_TRAYEK_FETCH_ALL_PORTAL,
} from "../actions/dashboardPimpinanAction";

const yearToDate = (state = { isLoad: false, data: {} }, action) => {
  switch (action.type) {
    case YEAR_To_DATE_FETCH_ALL:
      return { isload: action.load, data: action.val };
    default:
      return state;
  }
};

const trxBristore = (state = { isLoad: false, data: [] }, action) => {
  switch (action.type) {
    case TRX_BRISTORE_FETCH_ALL:
      return { isload: action.load, data: action.val };
    default:
      return state;
  }
};

const containerVoyageData = (state = { isLoad: false, data: {} }, action) => {
  switch (action.type) {
    case CONTAINER_VOYAGE_FETCH_ALL:
      return { isload: action.load, data: action.val };
    default:
      return state;
  }
};

const ruasTrayekData = (state = { isLoad: false, data: {} }, action) => {
  switch (action.type) {
    case RUAS_TRAYEK_FETCH_ALL:
      return { isload: action.load, data: action.val };
    default:
      return state;
  }
};
const ruasTrayekDataPortal = (state = { isLoad: false, data: {} }, action) => {
  switch (action.type) {
    case RUAS_TRAYEK_FETCH_ALL_PORTAL:
      return { isload: action.load, data: action.val };
    default:
      return state;
  }
};
const dashboardPimpinanReducer = combineReducers({
  yearToDate,
  trxBristore,
  containerVoyageData,
  ruasTrayekData,
  ruasTrayekDataPortal,
});

export default dashboardPimpinanReducer;
